<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('student_reports')" :isFilter="false"/>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('student_reports')" :isFilter="false"/>
            </template>
            <h6>{{ $t('select_report_type') }}</h6>
            <div class="border rounded p-5 mb-3">
                <multiselect
                    :clear-on-select="true"
                    :close-on-select="true"
                    :deselect-label="''"
                    :options="computeReportTypes"
                    :placeholder="$t('select')"
                    :select-label="''"
                    :selected-label="''"
                    label="text"
                    track-by="value"
                    v-model="reportType"
                />
            </div>
            <div class="col-12" v-if="reportType">
                <h6>
                    <span v-if="reportType && reportType.text">
                        {{ reportType.text }}
                    </span>
                </h6>
                <div class="border rounded p-5">
                    <component v-if="reportType && reportType.value" :is="reportType.value"/>
                </div>
            </div>
        </app-layout>
    </div>
</template>

<script>
// Template
import AppLayout from '@/layouts/AppLayout'
import Header from '@/layouts/AppLayout/Header'
import HeaderMobile from '@/layouts/AppLayout/HeaderMobile'
// Data
import ReportTypes from '../../data/StudentReportTypes'
// Pages
import MissingDocumentsReport from '@/modules/reports/pages/student/missingDocumentsReport/Index'
import StudentNotesReport from '@/modules/reports/pages/student/studentNotesReport/Index'
import FullScholarshipStudents from '@/modules/reports/pages/student/fullScholarshipStudents'
import RegistrationNumbersByFaculty from '@/modules/reports/pages/student/registrationNumbersByFaculty/Index'
import RegistrationNumbersByFacultyOsym from '@/modules/reports/pages/student/registrationNumbersByFacultyOsym/Index'
import NumberOfStudentsByStatus from '@/modules/reports/pages/student/numberOfStudentsByStatus/Index'
import YokRegistrationStatusReport from '@/modules/reports/pages/student/yokRegistrationStatusReport/Index'
import SummerSchoolReport from '@/modules/reports/pages/student/summerSchoolReport/Index'
import semesterStatusAnalysis from '@/modules/reports/pages/student/semesterStatusAnalysisReport/Index'
import examOverlapReport from '@/modules/reports/pages/student/examOverlapReport/index'
import studentsShouldTakeCourse from '@/modules/reports/pages/student/studentsShouldTakeCourse/Index'
import studentsShouldTakeCourses from '@/modules/reports/pages/student/studentsShouldTakeCourses/Index'
import studentsShouldTakeElective from '@/modules/reports/pages/student/studentsShouldTakeElective/Index'
import doubleMajorTerminationReport from '@/modules/reports/pages/student/doubleMajorTerminationReport/Index.vue'
import doubleMajorDismissalReport from '@/modules/reports/pages/student/doubleMajorDismissalReport/Index.vue'
import studentOverlapReport from '@/modules/reports/pages/student/studentOverlapReport/Index.vue'
import undergraduateTransferYokReport from "@/modules/reports/pages/student/undergraduateTransferYokReport/Index.vue"
import minorApplicationsYokReport from '@/modules/reports/pages/student/minorApplicationsYokReport/index'
import doubleMajorYokReport from '@/modules/reports/pages/student/doubleMajorYokReport/index'
import verticalTransition from '@/modules/reports/pages/student/verticalTransition/Index.vue'
import minorBranchDismissal from '@/modules/reports/pages/student/minorBranchDismissal/Index.vue'
import majorGraduateMinorBranch from '@/modules/reports/pages/student/majorGraduateMinorBranch/Index.vue'
import dischargeReport from '@/modules/reports/pages/student/dischargeReport/Index.vue'
import studentStatusChanges from '@/modules/reports/pages/student/studentStatusChanges/Index.vue'
import educationInformationReporting from '@/modules/reports/pages/student/educationInformationReporting/Index.vue'
import doubleMajorLeaveWithConsentReport from '@/modules/reports/pages/student/doubleMajorLeaveWithConsentReport/Index.vue'
import studentNumbersByNationalityAndFaculty from '@/modules/reports/pages/student/studentNumbersByNationalityAndFaculty/Index.vue'
import table11YokReport from '@/modules/reports/pages/student/table11YokReport/Index'
import table11bYokReport from '@/modules/reports/pages/student/table11bYokReport/Index'
import allPermitYokReport from '@/modules/reports/pages/student/allPermitYokReport/index'
import coopScholarshipStudentReport from '@/modules/reports/pages/student/coopScholarshipStudentReport/Index'
import thesisAndProjectsAdvisorReport from '@/modules/reports/pages/student/thesisAndProjectsAdvisorReport/Index'
import nonRenewalYuStudentReport from '@/modules/reports/pages/student/nonRenewalYuStudentReport'
import nonRenewalStudentReport from '@/modules/reports/pages/student/nonRenewalStudentReport'
import nonRenewalAllStudentReport from '@/modules/reports/pages/student/nonRenewalAllStudentReport'
import creditStudentReport from './creditStudentReport/Index.vue'

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        MissingDocumentsReport,
        doubleMajorDismissalReport,
        StudentNotesReport,
        doubleMajorTerminationReport,
        FullScholarshipStudents,
        RegistrationNumbersByFaculty,
        RegistrationNumbersByFacultyOsym,
        NumberOfStudentsByStatus,
        YokRegistrationStatusReport,
        SummerSchoolReport,
        examOverlapReport,
        studentsShouldTakeCourse,
        studentsShouldTakeElective,
        semesterStatusAnalysis,
        studentOverlapReport,
        undergraduateTransferYokReport,
        minorApplicationsYokReport,
        doubleMajorYokReport,
        studentsShouldTakeCourses,
        verticalTransition,
        minorBranchDismissal,
        majorGraduateMinorBranch,
        dischargeReport,
        studentStatusChanges,
        educationInformationReporting,
        doubleMajorLeaveWithConsentReport,
        studentNumbersByNationalityAndFaculty,
        table11YokReport,
        table11bYokReport,
        allPermitYokReport,
        coopScholarshipStudentReport,
        thesisAndProjectsAdvisorReport,
        nonRenewalYuStudentReport,
        nonRenewalStudentReport,
        nonRenewalAllStudentReport,
        creditStudentReport
    },
    metaInfo() {

        return {
            title: this.$t('student_reports')
        }
    },
    data() {
        return {
            reportType: null
        }
    },
    computed: {
        computeReportTypes() {
            return ReportTypes().filter((item) => {
                return this.checkPermission(item.permission)
            })
        }
    }
}
</script>
